import React from 'react';
import DOMPurify from 'dompurify';

const HtmlContent = ({ html }) => {
  const sanitizedHtml = DOMPurify.sanitize(html || '');
  return <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};

export default HtmlContent;
